var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocDestinationFlag2WhiteC82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / navi / soc_destination_flag_2_white_C8.2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-navi-/-soc_destination_flag_2_white_C8.2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "004_Icons-/-Charging_Power_and_Electricity-/-soc_destination_blank_stopover_flag",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,2 L16,6 L22,6 L22,46 L2,46 L2,6 L8,6 L8,2 L16,2 Z M20,8 L4,8 L4,44 L20,44 L20,8 Z M18,34.0351731 L18,42 L6,42 L6,34.0351731 L18,34.0351731 Z",
    id: "battery"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,20 L29,46 L27,46 L27,20 L29,20 Z M34,32 L34,35 L31,35 L31,32 L34,32 Z M40,32 L40,35 L37,35 L37,32 L40,32 Z M46,32 L46,35 L43,35 L43,32 L46,32 Z M37,29 L37,32 L34,32 L34,29 L37,29 Z M43,29 L43,32 L40,32 L40,29 L43,29 Z M34,26 L34,29 L31,29 L31,26 L34,26 Z M40,26 L40,29 L37,29 L37,26 L40,26 Z M46,26 L46,29 L43,29 L43,26 L46,26 Z M43,26 L40,26 L40,23 L37,23 L37,26 L34,26 L34,23 L31,23 L31,20 L34,20 L34,23 L37,23 L37,20 L40,20 L40,23 L43,23 L43,20 L46,20 L46,23 L43,23 L43,26 Z",
    id: "soc_destination_2_destination_flag"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocDestinationFlag2WhiteC82);
export default __webpack_public_path__ + "static/media/soc_destination_flag_2_white_C8.2.6bebfdb99a4e8667b3522a8e7bf96edd.svg";
export { ForwardRef as ReactComponent };